const defaultConfig = {
  surface: false,
  swipeDir: false,
  startX: 0,
  startY: 0,
  distX: 0,
  distY: 0,
  threshold: 150, // required min distance traveled to be considered swipe
  restraint: 100, // maximum distance allowed at the same time in perpendicular direction
  allowedTime: 300, // maximum time allowed to travel that distance
  elapsedTime: 0,
  startTime: 0,
  handleSwipe: () => {}
};

export default (config, callback) => {
  const _config = Object.assign(defaultConfig, config);
  let {
    surface,
    swipeDir,
    startX,
    startY,
    distX,
    distY,
    threshold,
    restraint,
    allowedTime,
    elapsedTime,
    startTime,
    handleSwipe
  } = _config;
  
  if (callback) handleSwipe = callback;

  const touchStart = (e) => {
    // console.log('start');
    const touchobj = e.changedTouches[0];

    swipeDir = 'none';
    startX = touchobj.pageX;
    startY = touchobj.pageY;
    startTime = new Date().getTime();

    // e.preventDefault();
  };

  const touchEnd = (e) => {
    // console.log('end');
    const touchobj = e.changedTouches[0];

    distX = touchobj.pageX - startX;
    distY = touchobj.pageY - startY;
    elapsedTime = new Date().getTime() - startTime;
    // console.log({ distX, distY, elapsedTime });

    if (elapsedTime <= allowedTime) {
      if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
        swipeDir = distX < 0 ? 'left' : 'right';
      } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
        swipeDir = distY < 0 ? 'up' : 'down';
      }
    }

    handleSwipe(swipeDir);
    // e.preventDefault();
  };

  const preventDefault = (e) => e.preventDefault();

  surface.addEventListener('touchstart', touchStart, { passive: true });
  // surface.addEventListener('touchmove', preventDefault, false);
  surface.addEventListener('touchend', touchEnd, false);
  
  const remove = () => {
    surface.removeEventListener('touchstart', touchStart, false);
    // surface.removeEventListener('touchmove', preventDefault, false);
    surface.removeEventListener('touchend', touchEnd, false);
  };

  return { remove };
};
